import { RidePhotos } from 'libs/ui';
import { cloneDeep } from 'libs/common';

export const CashboxPhotos = (props) => {
  const { row, ...rest } = props;

  const data = cloneDeep(row);
  data.data = {
    photos: {
      photo_1: '-',
      photo_2: data.photo,
      photo_3: '-',
    },
  };

  return <RidePhotos {...rest} row={data} />;
};
